__turbopack_context__.v({
  "className": "mona_sans_1cc0fa08-module__z4YbOa__className",
  "variable": "mona_sans_1cc0fa08-module__z4YbOa__variable",
});
